import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormTitle from '../../../../library/form/components/FormTitle'
import FormWrapper from '../../../../library/form/components/FormWrapper';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColTwo } from "../../../../library/layout/Index";
import DocAdminInfo from '../../../cmn/DocAdminInfo';

const UserHeaderViewer = (props) => {
    const { formObject, viewData } = props;

    if (!viewData)
        return (null)

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='User Details' />
                    </span>
                </UiTitle>

                <UiAction>
                    <DocAdminInfo formObject={formObject} rowKey="" headerKey="adminInfo"/>
                    <FormButton formObject={formObject} ksc="h" rowKey=""
                        starIcon={"edit"}
                        action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                        className="uiActionButton" text={<SarasTrans value="Edit" />}></FormButton>
                </UiAction>

            </UiViewHeading>
            <UiViewContent>
                <UiGridColTwo>
                    <div className="uiCol">
                        <ul>
                            <li>
                                <span className="uiLbl"><SarasTrans value = "User ID"/></span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "userId" }} className='uiVal' />
                            </li>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "profileContainer" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profileType" }} value="Relation" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "profileType" }} className='uiVal' />
                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "" }} value="Name" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "profile" }} className='uiVal' />
                            </FormWrapper>

                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "title" }} value="Title" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "title" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "firstName" }} value="First Name" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "firstName" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "middleName" }} value="Middle Name" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "middleName" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "lastName" }} value="Last Name" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "lastName" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "workflowGroup" }} value="Workflow Group" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "workflowGroup" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "department" }} value="Department" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "department" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "lineHead" }} value="Line Head" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "lineHead" }} className='uiVal' />
                            </li>
                        </ul>
                    </div>
                    <div className="uiCol">
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "nickName" }} value="Nick Name" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "nickName" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "email1" }} value="Email 1" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "email1" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "mobile1" }} value="Mobile 1" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "mobile1" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "userlogin" }} value="Login ID" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "userlogin" }} className='uiVal' />

                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "svLoginId" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "userPass" }} value="Password" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "userPass" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "language" }} value="Default Language" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "language" }} className='uiVal' />

                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "sortIndex" }} value="Sort Order" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "sortIndex" }} className='uiVal' />

                            </li>
                            <li>
                                <FormWrapper customWrapper="div" formObject={formObject} rowKey="" action={{ paramName: "svStatusContainer" }} >
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "userStatus" }} value="Is Active ?" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "userStatus" }} className='uiVal' />

                                    <span className="uiLblInLine">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "portal" }} value="Portal Access ?" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "portal" }} className='uiVal' />


                                    <span className="uiLblInLine">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "device" }} value="App Access ?" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "device" }} className='uiVal' />

                                </FormWrapper>
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "devLimit" }} value="Device Limit" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "devLimit" }} className='uiVal' />

                            </li>
                        </ul>
                    </div>
                </UiGridColTwo>
            </UiViewContent>
        </UiView>

    )
}

export default withView(UserHeaderViewer, "userHead", "userHead")